import TlSetTriggerAlarmModal from './tl-set-trigger-alarm-modal.vue'
export default TlSetTriggerAlarmModal
